import React from "react";
import ContactUs from "../contact-us";

const AboutPage = () => {
  return (
    <div className="max-w-screen-xl mx-auto py-14">
      {/* heading */}
      <section className="md:space-y-10 space-y-2 px-8 text-center">
        <h2 className="capitalize text-xl md:text-7xl font-semibold text-primary">
          About Us
        </h2>
        <p className="font-light md:text-xl text-2xs">
          Sleengshort was founded with one goal: to make business communication
          simpler, faster, and more effective. We understand that in today’s
          fast-paced world, reaching your audience at the right time with the
          right message is critical. That’s why we’ve built a platform that
          combines cutting-edge technology with user-friendly tools to help
          businesses of all sizes thrive.
        </p>
      </section>

      {/* summary */}
      <section className="bg-[#EAEAEA] p-6 mt-20 mx-4 md:mx-0 flex gap-6 items-center rounded-lg">
        <div>
          <h3 className="md:text-5xl text-xl font-medium px-10 md:px-0 text-center md:text-left">
            Born out of a passion for innovation,
          </h3>

          <img
            src="https://res.cloudinary.com/dbpb7sjus/image/upload/v1744329760/sleenshort/loegg3c7e8linakhlvxk.png"
            alt="about hero"
            className="block md:hidden md:w-full w-[11.875rem] h-[11.875rem] md:h-full mx-auto object-cover rounded-lg"
          />

          <p className="font-light md:text-xl text-xs text-center md:text-left">
            SleengShort started as a solution to the challenges businesses face
            in communicating with their customers. Today, we’re a trusted
            partner for companies across industries, providing Bulk SMS, SMS
            Campaigns, and USSD solutions that drive real results.
          </p>
        </div>

        <img
          src="https://res.cloudinary.com/dbpb7sjus/image/upload/v1744329760/sleenshort/loegg3c7e8linakhlvxk.png"
          alt="about hero"
          className="hidden md:block"
        />
      </section>

      {/* our commmitment */}
      <section className="bg-[#B6DCFE] rounded-lg p-8 md:p-20 mt-20 mx-6 md:mx-0">
        <header className="text-center mb-14 space-y-2 md:space-y-4">
          <h2 className="font-semibold text-xl md:text-5xl">Our Commitment</h2>
          <p className="font-light md:text-xl text-[0.5rem]">
            Our commitment to you goes beyond technology; it’s about delivering
            value, reliability, and innovation at every step. Here’s what you
            can expect from us
          </p>
        </header>

        <div className="flex md:flex-row flex-col justify-center gap-6 px-12 md:px-0">
          {[
            {
              image:
                "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744329803/sleenshort/kmaglgqabdnfhj9qbmlr.png",
              title: "Reliability",
              descr: "We deliver messages you can count on, every time.",
            },
            {
              image:
                "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744329802/sleenshort/gqp5zrk6j79tz0edmlz4.png",
              title: "Innovation",
              descr: "Constantly evolving to meet your needs.",
            },
            {
              image:
                "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744329802/sleenshort/ehq9nt5m8ojq3erzszcb.png",
              title: "Customer Success",
              descr: "Your growth is our priority.",
            },
          ].map((item, i) => (
            <div
              key={i}
              className="text-center space-y-4 w-full flex flex-col items-center"
            >
              <img src={item.image} alt={item.title} />
              <p className="font-semibold text-base md:text-xl">{item.title}</p>
              <p className="text-2xs md:text-base">{item.descr}</p>
            </div>
          ))}
        </div>
      </section>

      {/* our team */}
      <section className="mt-20 mx-8 md:mx-0">
        <header className="text-center mb-14 space-y-4">
          <h2 className="font-semibold text-xl md:text-5xl text-primary">
            Our Team
          </h2>
          <p className="font-light md:text-xl text-2xs">
            Our team is the heart of everything we do. We’re a diverse group of
            innovators, problem-solvers, and communication enthusiasts who are
            passionate about helping businesses connect with their audiences in
            meaningful ways.
          </p>
        </header>

        <div className="grid grid-cols-2 md:grid-cols-4 justify-center gap-5">
          {[
            {
              image:
                "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744329828/sleenshort/jg5trpno2zgkjsosag1n.jpg",
              name: "Ndubuisi Agbeyeke",
              role: "CEO/CO founder",
            },
            {
              image:
                "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744329829/sleenshort/pstyzkn9pr5qqj7mgptq.jpg",
              name: "Oyelere Biyi",
              role: "CTO/CO founder",
            },
            {
              image:
                "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744329857/sleenshort/ys7zxlb6zgr4dyfu4ghq.jpg",
              name: "Rita Osoh",
              role: "Head Of Operations",
            },
            {
              image:
                "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744329846/sleenshort/g9mk5j8bfi5t2ltsv8sg.jpg",
              name: "Favour Nwanze",
              role: "Regulatory And Telco Relations",
            },
          ].map((item, i) => (
            <div key={i}>
              <img
                src={item.image}
                alt={item.name}
                className="w-[10.25rem] h-[10.5rem] md:w-64 md:h-64 rounded-lg object-top object-cover"
              />
              <p className="text-primary font-semibold text-base md:text-xl pt-2 pb-1">
                {item.name}
              </p>
              <p className="text-secondary text-xs md:text-base">{item.role}</p>
            </div>
          ))}
        </div>
      </section>

      {/* contact us */}
      <ContactUs />
    </div>
  );
};

export default AboutPage;
